import request from '../../../Helpers/Request';

class Attributes {
    constructor(settings) {
        this.settings = settings;
    }

    index(connectionId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/attributes/index`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    show(connectionId, attributeId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/attributes/${attributeId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    store(connectionId, data) {
        return new Promise((resolve, reject) => {
            request('POST', `/clients/connections/${connectionId}/attributes`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(connectionId, attributeId, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${connectionId}/attributes/${attributeId}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    destroy(connectionId, attributeId) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/clients/connections/${connectionId}/attributes/${attributeId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getProductgroups(connectionId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/attributes`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getAttributes(connectionId, productGroupId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${connectionId}/attributes/${productGroupId}/values`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Attributes;
